import { Link } from "react-router-dom";
import Avatar from "../common/Avatar";
import { CATEGORY_LABELS } from "../../lib/constants";

function timeAgo(dateStr) {
  const now = new Date();
  const date = new Date(dateStr);
  const diffMs = now - date;
  const absDiff = Math.abs(diffMs);
  const isFuture = diffMs < 0;

  const minutes = Math.floor(absDiff / 60000);
  const hours = Math.floor(absDiff / 3600000);
  const days = Math.floor(absDiff / 86400000);

  let label;
  if (minutes < 1) label = "just now";
  else if (minutes < 60) label = `${minutes}m`;
  else if (hours < 24) label = `${hours}h`;
  else label = `${days}d`;

  if (label === "just now") return label;
  return isFuture ? `in ${label}` : `${label} ago`;
}

export default function RecentDeedsSection({ deeds }) {
  if (!deeds || deeds.length === 0) return null;

  return (
    <div className="mb-8">
      <h2 className="font-display text-lg font-semibold text-walnut mb-3">
        Recent Good Deeds
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {deeds.map((deed, i) => (
          <Link
            key={deed.created_at + deed.user?.id}
            to={deed.user?.id ? `/users/${deed.user.id}` : "#"}
            className="bg-cream rounded-lg shadow-card hover:shadow-card-hover transition-shadow p-4"
            style={{
              animation: "leaderboard-enter 0.5s ease-out forwards",
              animationDelay: `${i * 100}ms`,
              opacity: 0,
            }}
          >
            <div className="flex items-center gap-2 mb-2">
              {deed.user && <Avatar user={deed.user} size="sm" />}
              <span className="font-medium text-walnut text-sm truncate">
                {deed.user?.display_name || "Unknown"}
              </span>
            </div>
            {deed.post?.title && (
              <p className="font-medium text-walnut text-sm line-clamp-2 mb-2">
                {deed.post.title}
              </p>
            )}
            <div className="flex items-center gap-2 text-xs">
              {deed.post?.category && (
                <span className="px-2 py-0.5 rounded-full bg-terracotta/10 text-terracotta font-medium">
                  {CATEGORY_LABELS[deed.post.category] || deed.post.category}
                </span>
              )}
              <span className="px-2 py-0.5 rounded-full bg-sage/15 text-sage-dark font-semibold">
                +{deed.points} CP
              </span>
              <span className="text-walnut-light ml-auto">
                {timeAgo(deed.created_at)}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
